import { CartItem } from '@spa/store/modules/cart/types'
import { Cart } from '../cart'
import { CartItemRepository } from '../repository/cart-item-repository'
import { DefaultDealWithItemViaCartSpec } from '../specification/deal-with-item-via-cart/default-deal-with-item-via-cart-spec'
import { CommandResultContainer, DealWithItemViaCartSpec } from '../specification/deal-with-item-via-cart/index'
import { itemShouldExistInCart } from './assertion'

export class UpdateItemCountInCartService {
  static create(repository: CartItemRepository): UpdateItemCountInCartService {
    return new UpdateItemCountInCartService(
      repository,
      new DefaultDealWithItemViaCartSpec()
    )
  }

  private constructor(
    private readonly repository: CartItemRepository,
    private readonly dealWithItemViaCartSpec: DealWithItemViaCartSpec
  ) { }

  updateCount(item: CartItem, newCount: number, cart: Cart) {
    const command = this.dealWithItemViaCartSpec.apply(async (itemOnRun, cartOnRun) => {
      try {
        itemShouldExistInCart(itemOnRun, cartOnRun)

        /**
         * 親子商品には集約的な制約があるが、カートリソースとしては親子商品が等しく露出している。
         * client側のコードで集約が表現されるまでは、集約のルートとして機能する親商品に対してのみアクションを実行可能とする。
         */
        if (itemOnRun.isChild) {
          throw new Error(`Update count should not be called for child item(${itemOnRun.id})`)
        }

        return this.repository.changeCount(itemOnRun, newCount).then(result => result.fold(
          e => CommandResultContainer.createAsFail([e]),
          () => CommandResultContainer.createAsSuccess({
            ...itemOnRun,
            unitCount: newCount,
          })
        ))
      } catch (e) {
        return CommandResultContainer.createAsFail([e])
      }
    })

    return command(item, cart)
  }
}
